import * as React from "react";
const SvgImage = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={40} height={40} fill="none" {...props}>
    <g stroke="#191919" strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.3}>
      <path d="M27.778 10H12.222A2.22 2.22 0 0 0 10 12.222v15.556c0 1.227.995 2.222 2.222 2.222h15.556A2.22 2.22 0 0 0 30 27.778V12.222A2.22 2.22 0 0 0 27.778 10" />
      <path d="M16.111 17.778a1.667 1.667 0 1 0 0-3.334 1.667 1.667 0 0 0 0 3.334M30 23.333l-5.556-5.555L12.222 30" />
    </g>
  </svg>
);
export default SvgImage;
